import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var CsatQuestion = function CsatQuestion(_ref) {
  var handleNoClick = _ref.handleNoClick,
    handleYesClick = _ref.handleYesClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Ov8BDU",
    defaultMessage: [{
      "type": 0,
      "value": "Avez-vous trouvé ceci utile ?"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(RoundedButton, {
    onClick: handleYesClick
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "gCT/3L",
    defaultMessage: [{
      "type": 0,
      "value": "Oui"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(RoundedButton, {
    onClick: handleNoClick
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "DFu0VJ",
    defaultMessage: [{
      "type": 0,
      "value": "Non"
    }]
  }))));
};
var RoundedButton = styled.div.withConfig({
  displayName: "CsatQuestion__RoundedButton"
})(["display:flex;justify-content:center;align-items:center;background-color:", ";border-radius:", ";padding:", ";cursor:pointer;font-size:14px;& > p{pointer-events:none;}&:hover{background-color:", ";}"], Core.surface.subdued, getSpacing("3x"), getSpacing("1x", "3x"), Core.surface.subdued);